import { render, staticRenderFns } from "./CommunityBanner.vue?vue&type=template&id=59f10ccb&scoped=true&"
import script from "./CommunityBanner.vue?vue&type=script&lang=js&"
export * from "./CommunityBanner.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBanner.vue?vue&type=style&index=0&id=59f10ccb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f10ccb",
  null
  
)

export default component.exports